import { fmtMoney } from '../view.js';
/**
 * Деньги по канону (§3): от $100 — целыми («$400»), меньше — с центами через запятую («$50,50»).
 * Так же сравнение и подсказки «на $X больше» в диалогах правки.
 */
export function liveMoney(minor, currency) {
    return fmtMoney(minor, currency, Math.abs(minor) >= 10_000 ? 'whole' : 'cents');
}
/**
 * Деньги в окнах правки (бюджет, ставка): центы видны всегда, когда они не нули — даже от $100
 * («$150,50»); круглая сумма — по канону. Таблицы и обзор остаются на `liveMoney`.
 */
export function exactMoney(minor, currency) {
    return Math.abs(minor) % 100 === 0
        ? liveMoney(minor, currency)
        : fmtMoney(minor, currency, 'cents');
}
/** «1 изменение / 2 изменения / 5 изменений». */
export function plural(n, one, few, many) {
    const m10 = n % 10;
    const m100 = n % 100;
    if (m10 === 1 && m100 !== 11)
        return one;
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14))
        return few;
    return many;
}
export const changesWord = (n) => `${n} ${plural(n, 'изменение', 'изменения', 'изменений')}`;
/** «20:41» по Лос-Анджелесу — часовому поясу кабинетов Meta. */
export function laClock(iso) {
    if (!iso)
        return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return null;
    return new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'America/Los_Angeles',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).format(d);
}
/** Через сколько минут наступит момент (для «Доступно через 57 мин»); прошёл — 0. */
export function minutesUntil(iso, now = Date.now()) {
    if (!iso)
        return null;
    const t = Date.parse(iso);
    if (Number.isNaN(t))
        return null;
    return Math.max(0, Math.ceil((t - now) / 60_000));
}
/** «Исправьте 1 ошибку / 2 ошибки / 5 ошибок» (винительный — для кнопки). */
export const fixErrorsText = (n) => `Исправьте ${n} ${plural(n, 'ошибку', 'ошибки', 'ошибок')}`;
/** «1 поле / 2 поля / 5 полей». */
export const fieldsWord = (n) => `${n} ${plural(n, 'поле', 'поля', 'полей')}`;
//# sourceMappingURL=text.js.map